export default __webpack_public_path__ + "static/media/fall-with-skateboard.08aca4a9.svg";